import words from 'lodash/words';
import compact from 'lodash/compact';
import { isMobileSizeScreen, isWebImage, isWebVideo } from './utilsGlobal';


export function getMessageSnippet(message){
  if (message?.text) {
    return message.text.toString().substr(0, 100).trim();
  }
  else if (message?.attachments?.length) {
    return message.attachments.map(attachment => attachment.name).join(', ');
  }
  return '';
}


// Duplicates in src/workers/serviceWorker.js since service worker doesn't share code base w/ the rest of the project
// noinspection DuplicatedCode
export function getUserInitials(user){
  const firstName = user?.firstName || '';
  const lastName = user?.lastName || '';
  let namesArr = compact([firstName, lastName]);
  if (namesArr.length < 2) {
    namesArr = words([firstName, lastName].join(' '))
  }
  return namesArr.map(name => name[0]).slice(0, 2).join('');
}


// Duplicates in src/workers/serviceWorker.js since service worker doesn't share code base w/ the rest of the project
// noinspection DuplicatedCode
export function getUserFullName(user, separator = ' '){
  const firstName = user?.firstName || '';
  const lastName = user?.lastName || '';
  return compact([firstName, lastName]).join(separator);
}



window.getAvatarColorByUserId = getAvatarColorByUserId;
// Duplicates in src/workers/serviceWorker.js since service worker doesn't share code base w/ the rest of the project
// noinspection DuplicatedCode
export function getAvatarColorByUserId(userId){
  const defaultColor = '#0033FF';
  if (!userId) {
    return defaultColor;
  }
  const idDigits = userId.replace(/[a-z\-_=]/ig, '');
  const factor = +idDigits[idDigits.length - 1] + (0.1 * +idDigits[idDigits.length - 2]);
  const colorIndex = Math.floor(factor * 2);
  const colorDict = [
    '#b35766',
    '#b38b72',
    '#d4a471',
    '#e83b52',
    '#ef6e9c',
    '#fd4c26',
    '#f46e41',
    '#f87b31',
    '#bafc09',
    '#c6da6e',
    '#7dcb39',
    '#12972d',
    '#19c36a',
    '#79f2c2',
    '#79e6f2',
    '#066afc',
    '#0d01a6',
    '#c52bf0',
    '#9405df',
    '#273c4f',
  ];
  return colorDict[colorIndex];
}


export function getRoomName(room){
  if (room.id === 'default') {
    return '';
  }
  let normalizedRoomTitle = (room.title || '').toString().trim();

  // replace quotes (only if there are exactly two <"> symbols)
  if (normalizedRoomTitle.replace(/[^"]/ig, '').length === 2) {
    normalizedRoomTitle = normalizedRoomTitle
      .replace('"', '«')
      .replace('"', '»')
  }
  return normalizedRoomTitle;
}


// Duplicates in src/workers/serviceWorker.js since service worker doesn't share code base w/ the rest of the project
// noinspection DuplicatedCode
export function generateRoomURL(companyId, roomId){
  let url = '';
  if (companyId) {
    url += '/company/' + companyId;
    if (roomId) {
      url += '/room/' + roomId;
    }
  }
  return url;
}


export function isChatURL(pathname){
  const roomPathRe = /^\/company(\/[a-z0-9=-]+)?(\/room(\/[a-z0-9=-]+)?)?\/?$/i;
  const loginPathRe = /^\/login/i;
  return pathname === '/' || roomPathRe.test(pathname) || loginPathRe.test(pathname);
}


export function parseRoomURL(pathname){
  const pathnameArr = pathname.split('/');
  const companySubstrIndex = pathnameArr.indexOf('company') + 1;
  const roomSubstrIndex = pathnameArr.indexOf('room') + 1;
  return {
    companyId: companySubstrIndex ? pathnameArr[companySubstrIndex] : null,
    roomId: roomSubstrIndex ? pathnameArr[roomSubstrIndex] : null,
  };
}


export function focusChatTextArea(){
  if (!isMobileSizeScreen()) {
    setTimeout(() => {
      const element = document.getElementById('ChatTextAreaField');
      if (element) {
        element.focus();
      }
    });
  }
}


export function extractPreviewsFromMessage(message){
  const previews = [];
  message.attachments.forEach(attachment => {
    const { contentType } = attachment;
    const thumbnailUrl = attachment.thumbnails?.[0]?.url || '';
    if (thumbnailUrl && (isWebImage(contentType) || isWebVideo(contentType))) {
      previews.push({
        ...attachment,
        sender: message.sender,
      });
    }
  });
  return previews;
}
